module.exports = __webpack_public_path__ + "static/media/clouds-moon.f049a172.svg";